module.exports = __webpack_public_path__ + "img/fico.1f420c91.png";